var _path, _path2, _path3, _path4, _path5, _ellipse, _path6, _path7, _circle, _circle2, _circle3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgErrorInSystem(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 164,
    height: 105,
    viewBox: "0 0 164 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55 52L67 40",
    stroke: "#053668",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67 52L55 40",
    stroke: "#053668",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M99 52L111 40",
    stroke: "#053668",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M111 52L99 40",
    stroke: "#053668",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18 2H148V0H18V2ZM15 93V5H13V93H15ZM148 96H18V98H148V96ZM151 5V93H153V5H151ZM148 98C150.761 98 153 95.7614 153 93H151C151 94.6569 149.657 96 148 96V98ZM13 93C13 95.7614 15.2386 98 18 98V96C16.3431 96 15 94.6569 15 93H13ZM148 2C149.657 2 151 3.34315 151 5H153C153 2.23858 150.761 0 148 0V2ZM18 0C15.2386 0 13 2.23858 13 5H15C15 3.34315 16.3431 2 18 2V0Z",
    fill: "#053668"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.1,
    cx: 82,
    cy: 101,
    rx: 82,
    ry: 4,
    fill: "#053668"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M95 66C93.5109 63.2808 89.7458 61.3831 85 61.0517M72 66C72.7038 64.7148 73.9161 63.6131 75.5 62.7736M75.5 62.7736C77.6133 61.6534 80.3883 61 83.5 61C84.0095 61 84.51 61.0175 85 61.0517M75.5 62.7736C75.3333 65.0157 76 69.5 80 69.5C84 69.5 85 63.8678 85 61.0517",
    stroke: "#053668",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14 4C14 2.34315 15.3431 1 17 1H149C150.657 1 152 2.34315 152 4V10H14V4Z",
    fill: "#053668"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 5,
    r: 2,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 5,
    r: 2,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 5,
    r: 2,
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorInSystem);
export default __webpack_public_path__ + "static/media/error-in-system.f4ff2279.svg";
export { ForwardRef as ReactComponent };